import { ChangeDetectionStrategy, Component, effect, HostBinding, input } from '@angular/core';

import { RiskScoreLevel } from '@kr/models';

@Component({
  selector: 'kr-risk-score-value',
  standalone: true,
  template: `{{ score() }}`,
  styleUrl: './risk-score-value.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RiskScoreValueComponent {
  score = input<string>('');
  level = input<RiskScoreLevel>(null);

  @HostBinding('class') scoreStatusClass = '';

  scoreEffect = effect(() => {
    const scoreLevel = this.level();
    if (!scoreLevel) return;

    this.scoreStatusClass = scoreLevel;
  });
}
